import palette from "./palette";

const CranecastTypography = {
  fontFamily: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
  h1: {
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
    color: palette.text.primary,
    fontWeight: 700,
    fontSize: "2.25rem", // 36px
    letterSpacing: "-.05em",
    lineHeight: "2.5rem", // 40px
    marginBottom: "1rem",
  },
  h2: {
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
    color: palette.text.primary,
    fontWeight: 600, // Semibold
    fontSize: "1.875rem", // 30px
    letterSpacing: "-0.025em", // tight
    lineHeight: "1.2",
  },
  h3: {
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
    color: palette.text.primary,
    fontWeight: 700,
    fontSize: "1.5rem", // 24px
    letterSpacing: "-0.025em",
    lineHeight: "2rem", // 32px
  },
  h4: {
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
    color: palette.text.primary,
    fontWeight: 600, // Semibold
    fontSize: "1.25rem", // 20px
    letterSpacing: "-0.025em", // tight
    lineHeight: "1.4",
  },
  h5: {
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
    color: palette.text.primary,
    fontWeight: 500, // Medium
    fontSize: "1.125rem", // 18px
    letterSpacing: "-0.025em", // tight
    lineHeight: "1.4",
  },
  h6: {
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
    color: palette.text.primary,
    fontWeight: 500, // Medium
    fontSize: "1rem", // 16px
    letterSpacing: "-0.025em", // tight
    lineHeight: "1.5",
  },
  subtitle1: {
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
    color: palette.text.secondary,
    fontWeight: 400, // Regular
    fontSize: "1rem", // 16px
    letterSpacing: "-0.025em", // tight
    lineHeight: "1.5",
  },
  subtitle2: {
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
    color: palette.text.secondary,
    fontWeight: 400, // Regular
    fontSize: "0.875rem", // 14px
    letterSpacing: "-0.025em", // tight
    lineHeight: "1.4",
  },
  body1: {
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
    color: palette.text.primary,
    fontWeight: 400, // Regular
    fontSize: "1rem", // 16px
    letterSpacing: "-0.025em", // tight
    lineHeight: "1.6",
  },
  body2: {
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
    color: palette.text.secondary,
    fontWeight: 400, // Regular
    fontSize: "0.875rem", // 14px
    letterSpacing: "-0.025em", // tight
    lineHeight: "1.5",
  },
  button: {
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
    color: palette.text.primary,
    fontWeight: 500, // Medium
    fontSize: "0.875rem", // 14px
    letterSpacing: "-0.025em", // tight
    lineHeight: "1.4",
    textTransform: "none" as const, // Prevent uppercase
  },
  caption: {
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
    color: palette.text.disabled,
    fontWeight: 400, // Regular
    fontSize: "0.75rem", // 12px
    letterSpacing: "-0.025em", // tight
    lineHeight: "1.4",
  },
  overline: {
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
    color: palette.text.disabled,
    fontWeight: 500, // Medium
    fontSize: "0.75rem", // 12px
    letterSpacing: "0.1em", // wide
    lineHeight: "1.4",
    textTransform: "uppercase" as const,
  },
};

export default CranecastTypography;